import React, { useState, KeyboardEvent, MouseEvent } from 'react';
import classnames from 'classnames';

import ChevronRight from '@johnlewispartnership/wtr-ingredients/dist/Icon/ChevronRight';
import Typography from '@johnlewispartnership/wtr-ingredients/foundations/typography';

import styles from './SearchResult.scss';

interface Item {
  name?: string;
  extraData?: string;
}

interface SearchResultProps {
  id: string;
  setSize: number;
  itemNumber: number;
  item: Item;
  onClick: (event: MouseEvent<HTMLLIElement>) => void;
  onKeyDown: (event: KeyboardEvent<HTMLLIElement>) => void;
}

const SearchResult: React.FC<SearchResultProps> = ({
  id,
  setSize,
  itemNumber,
  item,
  onClick,
  onKeyDown,
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const { name = '', extraData = '' } = item;

  const posInSet = itemNumber + 1;

  const handleFocus = () => setIsFocused(true);
  const handleBlur = () => setIsFocused(false);

  return (
    <li
      key={id}
      id={`search-item_${itemNumber}`}
      className={styles.searchOption}
      onFocus={handleFocus}
      onBlur={handleBlur}
      onKeyDown={onKeyDown}
      onClick={onClick}
      aria-setsize={setSize}
      aria-posinset={posInSet}
      aria-selected={isFocused}
      role="option"
      tabIndex={-1}
    >
      <div
        id={`search-item-details_${itemNumber}`}
        data-test={`search-item_${itemNumber}`}
        className={classnames(styles.searchItem, {
          [styles.searchItemExtraData]: !!extraData,
          [styles.searchItemWithoutExtraData]: !extraData,
        })}
        role="button"
      >
        {extraData ? (
          <>
            <Typography styleAs="paragraphSmallLight" textStyle="body-s" noWrap noMargins>
              {name}
            </Typography>
            <Typography styleAs="paragraphSmall" textStyle="body-s" noWrap noMargins>
              {extraData}
            </Typography>
            <ChevronRight className={styles.chevronRight} />
          </>
        ) : (
          <Typography noWrap>{name}</Typography>
        )}
      </div>
    </li>
  );
};

export default SearchResult;
